// app/javascript/controllers/upload_selector_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox", 
    "selectAll", 
    "selectedCount", 
    "visibleCount", 
    "search", 
    "row",
    "label"
  ]

  connect() {
    this.updateCounts()
    this.updateSelectAllState()
    this.makeLabelsClickable()
  }

  // Wird aufgerufen wenn sich ein Upload-Checkbox ändert
  checkboxChanged() {
    this.updateCounts()
    this.updateSelectAllState()
  }

  // Wird aufgerufen wenn Select-All Checkbox geändert wird
  selectAllChanged() {
    const isChecked = this.selectAllTarget.checked
    this.visibleCheckboxes.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateCounts()
  }

  // Wird aufgerufen bei Eingabe in Suchfeld
  search() {
    const searchTerm = this.searchTarget.value.toLowerCase()
    
    this.rowTargets.forEach(row => {
      const name = row.dataset.name || ''
      const remark = row.dataset.remark || ''
      const trip = row.dataset.trip || ''
      
      const matches = name.includes(searchTerm) || 
                     remark.includes(searchTerm) || 
                     trip.includes(searchTerm)
      
      row.style.display = matches ? '' : 'none'
    })
    
    this.updateCounts()
    this.updateSelectAllState()
  }

  // Private Methoden
  updateCounts() {
    if (this.hasSelectedCountTarget) {
      const checked = this.checkboxTargets.filter(cb => cb.checked).length
      this.selectedCountTarget.textContent = checked
    }
    
    if (this.hasVisibleCountTarget) {
      const visible = this.visibleRows.length
      this.visibleCountTarget.textContent = visible
    }
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return
    
    const visibleCheckboxes = this.visibleCheckboxes
    const checkedVisible = visibleCheckboxes.filter(cb => cb.checked)
    
    if (checkedVisible.length === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    } else if (checkedVisible.length === visibleCheckboxes.length) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    }
  }

  makeLabelsClickable() {
    this.labelTargets.forEach(label => {
      label.style.cursor = 'pointer'
    })
  }

  // Getter für häufig verwendete Elemente
  get visibleRows() {
    return this.rowTargets.filter(row => 
      !row.style.display || row.style.display !== 'none'
    )
  }

  get visibleCheckboxes() {
    return this.visibleRows.map(row => 
      row.querySelector('.upload-checkbox')
    ).filter(Boolean)
  }
}
